import styled from 'styled-components';

import colors from '../../styles/colors';

interface StyledPropsInterface {
  size: number;
  image: string;
  variant: 'primary' | 'secondary';
}

export const StyledContainer = styled.div``;

export const StyledAvatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props: StyledPropsInterface) => props.size}px;
  height: ${(props: StyledPropsInterface) => props.size}px;

  border-radius: 50%;

  ${(props: StyledPropsInterface) =>
    props.image
      ? `
        background-image: url(${props.image});
        background-size: cover;
      `
      : props.variant === 'primary'
      ? `
        border: solid ${props.size < 96 ? 1 : 2}px ${colors.primary};
        background-color: #fbccda;
        color: ${colors.primary};
        font-size: ${props.size / 2.67}px;
        font-weight: 600;
      `
      : `
        background: rgb(179, 179, 179);
        border: none;

        svg {
          color: white;
        }
      `}
`;
